import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentUserQuery } from '../../../user/hooks/useCurrentUserQuery';
import { useCurrentEventQuery } from '../../hooks/useCurrentEventQuery';
import { useCurrentMilestone } from '../../hooks/useCurrentMilestone';
import { useLeaveEventMutation } from '../../hooks/useLeaveEventMutation';
import { useNextMilestone } from '../../hooks/useNextMilestone';

export const usePayment = () => {
  const navigate = useNavigate();
  const { data: currentEventData, loading } = useCurrentEventQuery();
  const { data: currentUserData } = useCurrentUserQuery();
  const { leaveEvent } = useLeaveEventMutation();

  const currentEvent = useMemo(
    () => currentEventData?.currentEvent ?? null,
    [currentEventData],
  );

  const currentUser = useMemo(
    () => currentUserData?.currentUser ?? null,
    [currentUserData],
  );
  const hasGivenInformation =
    currentUser?.firstname && currentUser?.lastname && currentUser?.birthdate;

  const currentMilestone = useCurrentMilestone(currentEvent?.milestones ?? []);
  const nextMilestone = useNextMilestone(currentEvent?.milestones ?? []);

  const onGoToDashboard = () => {
    navigate('/dashboard');
  };

  const onGoToPaymentForSomeone = () => {
    navigate('/payment/for-someone');
  };

  const onGoToEventRegister = () => {
    navigate('/event-register');
  };

  const onLeaveEvent = () => {
    if (!currentEvent) {
      return;
    }

    leaveEvent({
      eventId: currentEvent?.id,
    });
  };

  return {
    hasGivenInformation,
    loading,
    currentEvent,
    currentMilestone,
    nextMilestone,
    onGoToDashboard,
    onGoToEventRegister,
    onLeaveEvent,
    onGoToPaymentForSomeone,
  };
};
